import { createStore } from 'vuex'

export default createStore({
	state: {
		isGeneratePopup: false,
		visitedModules: {}
	},
	getters: {
		getIsGeneratePopup(state) {
			return state.isGeneratePopup
		},
		getVisitedModules(state) {
			return state.visitedModules
		}
	},
	mutations: {
		setIsGeneratePopup(state, value) {
			state.isGeneratePopup = value
		},
		setVisitedModules(state, payload) {
			state.visitedModules = { ...state.visitedModules, ...payload }
		}
	},
	actions: {
		updateIsGeneratePopup({ commit }, value) {
			commit('setIsGeneratePopup', value)
		},
		updateVisitedModules({ commit }, payload) {
			commit('setVisitedModules', payload)
		}
	},
	modules: {}
})